/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { setLinkedAccountsMenuStatus } from '../../../redux/actions/setMobileMenusStatus';
import { PAMMState } from '../../../redux/reducers/rootReducer';
import { Investor } from '../../../types/investorTypes';
import LocalStorageUtils from '../../../utils/local-storage';
import WalletListIcon from '../../../icons/WalletListIcon';
import { applyStyles } from '../../../utils/applyStyles';
import fetchInvestorDetailsAsync from '../../../redux/actions/investor/fetchInvestorDetails';
import styles from './UserMenuMobile.module.css';

const LinkedAccountsMenuMobile: React.FC<any> = ({ onSwipe, onCancel }): JSX.Element => {
  const dispatch = useDispatch();
  const api = useSelector((state: PAMMState) => state.configReducer.api);

  const show = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showlinkedAccountsMenu);
  const investor: Investor = useSelector((state: PAMMState) => state.investorReducer.investor);
  const linkedAccounts: Array<Investor> = useSelector((state: PAMMState) => state.investorsReducer.investors);

  const handleSelectLinkedAccount = (id: number): void => {
    dispatch(setLinkedAccountsMenuStatus(false));
    dispatch(fetchInvestorDetailsAsync(api, id));
    LocalStorageUtils.putValueToLocalStorage('linkedIdMobile', id.toString());
  };

  return (
    <div
      className={applyStyles([styles['menu'], show ? styles['show'] : styles['hide']])}
      onPointerMove={(event) => onSwipe(event)}
      onPointerCancel={() => onCancel('LinkedAccountsMenu')}
    >
      <div className={applyStyles([styles['header'], 'text-h4-semibold'])}>
        <FormattedMessage id="chooseAccount" />
      </div>

      {/* List of Accounts */}
      <div className={styles['account-list']}>
        {linkedAccounts.map((linkedAccount: Investor) => {
          const isActive = linkedAccount.Id === investor?.Id;

          return (
            <div
              key={linkedAccount?.Id}
              className={styles['account-item']}
              onClick={() => handleSelectLinkedAccount(linkedAccount?.Id)}
            >
              <div className={`${styles['indicator']} ${isActive ? styles['active'] : ''}`} />
              <span className={applyStyles([styles['icon'], isActive ? styles['active'] : ''])}>
                <WalletListIcon />
              </span>

              {/* Account Name and ID */}
              <div className="text-regular d-flex">
                <span
                  className={applyStyles([styles['account-name'], 'text-h4', 'truncate-name', isActive ? styles['active'] : ''])}
                >
                  {linkedAccount?.Name}
                </span>
                <span className={styles['account-id']}>
                  (<FormattedMessage id="id" />: {linkedAccount?.Id})
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LinkedAccountsMenuMobile;
